import { OutlinedIcon } from '@one/icons';
import { OwcIcon, OwcTypography } from '@one/react';
import { useNativeBackButton } from 'core/platform/use-native-back-button.hook';
import { WorkflowHeaderLayout, WorkflowHeaderTitle } from './workflow-header.style.component';

interface WorkflowHeaderComponentProps {
  title: string;
  subtitle?: string;
  icon?: OutlinedIcon;
  onClick: () => void;
}

export const WorkflowHeaderComponent: React.FC<WorkflowHeaderComponentProps> = props => {
  const { title, subtitle, icon = 'arrow_leftwards', onClick } = props;

  useNativeBackButton(onClick);

  return (
    <WorkflowHeaderLayout slot="header" separator={false} data-testid="workflow-header">
      <OwcIcon slot="prefix" name={icon} onClick={onClick} data-testid="workflow-header-icon" />
      <WorkflowHeaderTitle>
        <OwcTypography variant="subtitle1">{title}</OwcTypography>
        {subtitle && <OwcTypography variant="caption">{subtitle}</OwcTypography>}
      </WorkflowHeaderTitle>
    </WorkflowHeaderLayout>
  );
};
